<template>
  <div class="public-shop">
    <div class="text-center p-5" v-if="loading">
      <div class="spinner-border"></div>
      <p class="mt-2">Mencari produk...</p>
    </div>
    <div v-else-if="!product" class="text-center p-5">
      <h3>Produk tidak ditemukan</h3>
      <p>URL produk mungkin salah atau produk sudah ditarik.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() { return { loading: true, product: null }; },
  async mounted() {
    const slug = this.$route.params.slug;
    try {
      // Bypass auth header
      const base = (axios.defaults.baseURL || '').replace(/\/api\/v1\/?$/, '');
      const r = await axios.get(base + '/api/public/produk/' + slug, { headers: { Authorization: '' } });
      const data = r.data.data;
      this.product = data.product;
      // Auto-redirect to /toko/:shopSlug/produk/:productSlug
      if (data.redirect_to) {
        this.$router.replace(data.redirect_to);
        return;
      }
      this.loading = false;
    } catch (e) {
      this.product = null;
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.public-shop { background: #f4f6f8; min-height: 100vh; }
</style>
